import React from 'react';

import './contact.styles.scss';

/* eslint-disable-next-line */
export interface ContactProps {}

export function Contact(props: ContactProps) {
  return (
    <div className="contact-info pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="contact-info-box">
              <div className="back-icon">
                <i className="bx bx-map"></i>
              </div>
              <div className="icon">
                <i className="bx bx-map"></i>
              </div>
              <h3>Our Address</h3>
              <p>
                Office:{' '}
                <a
                  href="https://goo.gl/maps/bayTNvt1JU3geZuBA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  169 Enterprise Blvd Suite 300 Markham, ON L6G 0E7, Canada
                </a>
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6">
            <div className="contact-info-box">
              <div className="back-icon">
                <i className="bx bx-phone-call"></i>
              </div>
              <div className="icon">
                <i className="bx bx-phone-call"></i>
              </div>
              <h3>Contact</h3>
              <p>
                Mobile: <a href="tel:+12898009711">+ 1 (289) 800-9711</a>
              </p>
              <p>
                Email: <a href="mailto:info@hopin.com">info@hopintech.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
